"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//Objet réunissant les paramètres pouvant être utiles pour les filtres checkbox sur les datatables
var FilterCheckBoxSettings = /** @class */function () {
    function FilterCheckBoxSettings() {
        var _this = this;
        this.isFilterExist = function () {
            return _this.typeFiltre === "exist";
        };
        this.typeFiltre = "classic";
        this.defaultValue = true;
    }
    return FilterCheckBoxSettings;
}();
exports.FilterCheckBoxSettings = FilterCheckBoxSettings;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Datatable/FilterCheckBoxSettingsClass.ts
// module id = 175
// module chunks = 0